import { Breadcrumb, Input, Space, Spin, Table } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ButtonField from "../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import NewPrDetails from "../feature/PR/NewPrDetails";
import AssignedSiteEmployeeGrid from "../feature/PR/AssignedSiteEmployeeGrid";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getRequest } from "../axios";
import { ErrorNotificationMsg } from "../utils/Notifications";
import "jspdf-autotable";
import PreviewForPDF from "./PreviewForPDF";

const SendForApprovalMyForm = () => {
  const { t } = useTranslation();
  const buttonRef = useRef(null);
  const { id } = useParams();
  const pdfContainerRef = useRef(null);
  const navigate = useNavigate();
  const [prNum, setPrNum] = useState(null);
  const [material, setMaterial] = useState(null);
  const [purchaseRequisitionDetails, setPurchaseRequisitionDetails] = useState(
    []
  );
  const [isDownloading, setIsDownloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const formRef = useRef();
  const { Panel } = Collapse;
  // useEffect(() => {
  //   const getPurchaseRequisitionDetails = async () => {
  //     setLoading(true);

  //     try {
  //       let apiResponse = await getRequest(`purchase-requisition/${id}`);
  //       console.log("apiResponse 441 ", apiResponse);

  //       if (apiResponse.data.data) {
  //         setPurchaseRequisitionDetails(apiResponse.data.data);
  //         setPrNum(apiResponse.data.data.pr_number);
  //         setMaterial(apiResponse.data.data.pr_type);
  //       } else {
  //         ErrorNotificationMsg(t("error_in_purchase_requisition"));
  //       }
  //       setLoading(false);
  //     } catch (error) {
  //       setLoading(false);
  //     }
  //   };
  //   getPurchaseRequisitionDetails();
  // }, []);

  const renderTables = () => {
    if (!purchaseRequisitionDetails.purchase_requisition_details) return null;

    const groupedDetails = {};
    purchaseRequisitionDetails.purchase_requisition_details.forEach(
      (detail) => {
        const subCategory = detail.sub_category;
        if (!groupedDetails[subCategory]) {
          groupedDetails[subCategory] = { sites: {}, details: [] };
        }
        groupedDetails[subCategory].details.push(detail);
        detail.site_wise.forEach((site) => {
          groupedDetails[subCategory].sites[site.site_name] = true;
        });
      }
    );

    return Object.entries(groupedDetails).map(
      ([subCategory, { sites, details }], index) => {
        const siteNames = Object.keys(sites);
        const site_wise = Object.keys(sites);
        const data = [];
        details.map((detail, index) =>
          data.push({
            ...detail,
            srNo: index,
            key: detail.pr_details_id.toString(),
            totalQuantity: `${detail.total_quantity} ${detail.unit_of_measurement_name}`,
          })
        );

        const siteNameColumns = siteNames.map((site, index) => ({
          title: site,
          dataIndex: index,
          key: index,
          width: 170,
        }));

        const siteWiseColumns = site_wise.map((site, siteIndex) => ({
          title: "Site Input",
          dataIndex: `siteInput_${siteIndex}`,
          key: `siteInput_${siteIndex}`,
          render: (text, record) => {
            const matchingSite = record.site_wise.find(
              (s) => s.site_name === site
            );
            if (matchingSite) {
              return (
                <div className="lblvalue" style={{ marginLeft: "5px" }}>
                  {matchingSite?.quantity}
                </div>
              );
            }
            return null; // If no matching site found, render nothing
          },
          width: 170,
        }));

        const columns1 = [
          {
            title: `${index + 1}`,
            dataIndex: "srNo",
            key: "1",
            width: 50,
            render: (text, record, ind) => `${index + 1}.${ind + 1}`,
          },

          {
            title: `${subCategory}`,
            dataIndex: `${subCategory}`,
            key: `${subCategory}`,
            render: (text, record) => {
              console.log("record 1 ", record);
              return (
                <>
                  {record.site_wise.map((site, siteIndex) => (
                    <Input
                      readOnly
                      key={siteIndex}
                      style={{ width: "150px" }}
                      value={site.quantity}
                    />
                  ))}
                </>
              );
            },
          },
          ...siteNameColumns,

          {
            title: "TOTAL QTY.",
            dataIndex: "TOTAL",
            key: "8",
            width: 180,
          },
          {
            title: "UoM.",
            dataIndex: "UOM",
            key: "7",
            width: 160,
          },
        ];

        const thead = <Table columns={columns1} />;

        return (
          <Panel key={index.toString()} header={thead}>
            <Table
              columns={[
                {
                  title: `${index + 1}`,
                  dataIndex: "srNo",
                  key: "1",
                  width: 50,
                  render: (text, record, ind) => `${index + 1}.${ind + 1}`,
                },
                {
                  title: "Type Name",
                  dataIndex: "material_type_name_by_company",
                  key: "material_type_name_by_company",
                  // width: 470,
                },
                ...siteWiseColumns,
                {
                  title: "Total Quantity",
                  dataIndex: "totalQuantity",
                  key: "totalQuantity",
                  width: 180,
                  render: (text, record) => (
                    <div className="lblvalue" style={{ marginLeft: "5px" }}>
                      {record.total_quantity}
                    </div>
                  ),
                },
                {
                  title: "UOM",
                  dataIndex: "unit_of_measurement",
                  key: "unit_of_measurement",
                  width: 160,
                  render: (text, record) => {
                    return (
                      <div className="lblvalue" style={{ marginLeft: "5px" }}>
                        {record.unit_of_measurement_name}
                      </div>
                    );
                  },
                },
              ]}
              dataSource={data}
              //  pagination={false}
            />
          </Panel>
        );
      }
    );
  };

  const downloadAsPDF = () => {
    if (pdfContainerRef.current) {
        setIsDownloading(true);
        if (buttonRef.current) {
            buttonRef.current.classList.add('hide-in-pdf');
        }

        html2canvas(pdfContainerRef.current, {
            useCORS: true,
            scale: 1.5,
            logging: true,
        })
            .then((canvas) => {
                const imgData = canvas.toDataURL("image/png");

                const pdf = new jsPDF('l', 'mm', 'a4');
                const imgProps = pdf.getImageProperties(imgData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                pdf.save(`Preview Purchase Order-${id}.pdf`);

                if (buttonRef.current) {
                    buttonRef.current.classList.remove('hide-in-pdf');
                }
                setIsDownloading(false);
            })
            .catch((error) => {
                console.error("Error generating PDF:", error);
                if (buttonRef.current) {
                    buttonRef.current.classList.remove('hide-in-pdf');
                }
                setIsDownloading(false);
            });
    } else {
        console.error("PDF container reference is not defined.");
    }
};


  return (
    <div id="content-to-download" ref={pdfContainerRef}>
      <Spin spinning={loading} >
          <PreviewForPDF RFQID={id} />
      </Spin>
      {/* <ButtonField
        label={isDownloading ? "Downloading..." : "Generate PDF"}
        onClick={downloadAsPDF}
        ref={buttonRef}
        className="hide-when-downloading"
      /> */}
    </div>
  );
};

export default SendForApprovalMyForm;
